import React from 'react';
import {theme} from '../../theme/theme';
import {Box} from '../../box';
import {FrameworkImage} from '../../image-renderer';
import {Typography} from '../../typography';

export interface CoverImageCurationProps {
  image?: string;
  logo?: string;
  artistName?: string | null;
}

export const CoverImageCuration: React.FC<CoverImageCurationProps> = ({
  image,
  logo,
  artistName,
}: CoverImageCurationProps) => {
  return (
    <Box
      alignItems="flex-start"
      backgroundRepeat="no-repeat"
      backgroundPosition="center"
      backgroundSize={['contain', 'cover']}
      width="100%"
      height={['300px', '400px']}
      borderBottomWidth="one"
      borderBottomStyle="solid"
      borderBottomColor="outlines"
      css={{
        backgroundImage: `url(${image})`,
      }}
    >
      {logo ? (
        <Box height={['30px', '40px', '50px', '60px']} width="100%">
          <FrameworkImage
            src={logo}
            alt="artist logo"
            layout="fill"
            objectFit="contain"
            objectPosition="left"
          />
        </Box>
      ) : null}
      {!logo && artistName ? (
        <Typography
          textStyle={['h2', 'h1']}
          color="textDefault"
          style={{zIndex: 1}}
        >
          {artistName}
        </Typography>
      ) : null}
    </Box>
  );
};
